// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { actionCreatorsList } from '../../redux/rootActionCreator';
import { CreditMethod } from '../../types/Model';
import { AxiosError } from 'axios';
import { buyExam, endExam, retakeQuestion, getUploadUrl } from '../../apis/exam';

const {
  getExamInformationActions,
} = actionCreatorsList;

export function useFetchExamInformation(id: number, { workshopId, iltCourseId, callback, preventLoading }: { workshopId?: number; iltCourseId?: number; callback?: () => void; preventLoading?: boolean }): () => void {
  const dispatch = useDispatch();
  const fetch = useCallback(() => {
    dispatch(getExamInformationActions.request({ id, condition: 'Buy', workshopId, iltCourseId, preventLoading }));
    callback && callback();
  }, [id, workshopId, iltCourseId, callback]);

  return fetch;
}

interface BuyExamOption {
  creditMethod: CreditMethod,
  workshopId?: number;
  courseId?: number;
  iltCourseId?: number;
  success?: () => void;
  onError?: (error: string) => void;
}

export function useBuyExam(id: number, { creditMethod, workshopId, courseId, iltCourseId }: BuyExamOption): any {

  const result = buyExam(id, false, creditMethod, workshopId, courseId, iltCourseId)
    .then((response) => {
      // handle success case here
      return response.data;
    })
    .catch((error: AxiosError) => {
      const message = error.response?.data || 'Unhandled Error';
      return message;
    })
  return result;
}

export function useTestExam(id: number): any {
  const result = buyExam(id, true)
    .then((response) => {
      // handle success case here
      return response.data;
    })
    .catch((error: AxiosError) => {
      const message = error.response?.data || 'Unhandled Error';
      // onError && onError(message);
      return message;
    })
  return result;
}

export function useEndExam(id: number, examRecordId: number, choosedAnswer: any, choosedQnaAnswer: any): any {
  const result = endExam(id, examRecordId, choosedAnswer, choosedQnaAnswer)
    .then((response) => {
      // handle success case here
      return response.data;
    })
    .catch((error: AxiosError) => {
      const message = error.response?.data || 'Unhandled Error';
      // onError && onError(message);
      return message;
    })
  return result;
}

export function imgProcess(baseUrl: string, markdown: string): any {
  const uriParser = (uri: string) => {
    return uri.indexOf('./') === 0 ? `${baseUrl}/${uri.slice(2)}` : uri;
  };
  let textContent = markdown;
  let imgContent = ''
  const imageTagRegex = new RegExp(/<img src="([^"]+)"([^>]*>)/g);
  // 處理題目的 img
  if (markdown.match(imageTagRegex)) {
    textContent = markdown.replace(imageTagRegex, '');
    const result = imageTagRegex.exec(markdown) || [];
    imgContent = uriParser(result[1]);
  }
  return [textContent, imgContent];
}

export function optionImgListProcess(baseUrl: string, optionList: string[]): any {
  const uriParser = (uri: string) => {
    return uri.indexOf('./') === 0 ? `${baseUrl}/${uri.slice(2)}` : uri;
  };
  const imageTagRegex = new RegExp(/<img src="([^"]+)"([^>]*>)/g);
  const optionImgList: string[] = [];
  const optionTextList: string[] = [];
  optionList.forEach((item: any) => {
    // 處理答案的 img
    if (item.match(imageTagRegex)) {
      const optionResult = imageTagRegex.exec(item) || [];
      const imgContent = uriParser(optionResult[1]);
      optionImgList.push(imgContent);
      optionTextList.push(item.replace(imageTagRegex, ''));
    } else {
      optionImgList.push('');
      optionTextList.push(item);
    }

  })
  return [optionTextList, optionImgList];
}

export function useRetakeQuestion(id: number): any {
  const result = retakeQuestion(id)
    .then((response) => {
      // handle success case here
      return response.data;
    })
    .catch((error: AxiosError) => {
      const message = error.response?.data || 'Unhandled Error';
      // onError && onError(message);
      return message;
    })
  return result;
}

export function getUploadFileUrl(examId: number, examRecordId: number, fileList: any): any {
  const result = getUploadUrl(examId, examRecordId, fileList)
    .then((response) => {
      // handle success case here
      return response.data;
    })
    .catch((error: AxiosError) => {
      const message = error.response?.data || 'Unhandled Error';
      // onError && onError(message);
      return message;
    })
  return result;
}
